module.exports = __webpack_public_path__ + "static/media/ts2.051a6702.svg";